module.exports = __webpack_public_path__ + "img/live-left.570edd31.svg";